<template>
  <div style="margin-bottom: 24px;">
    <div style="display: flex; justify-content: space-around">
      <el-scrollbar height="500px" class="showBox">
        <p style="margin-bottom: 16px;">展示平台</p>
        <div style="margin-bottom: 16px;padding-bottom: 16px; border-bottom: 1px solid #ededed;">
          <label style="font-weight: bold;margin-bottom: 8px;">鸿蒙平台：</label>&nbsp;
          <el-checkbox :indeterminate="isIndeterminateHm" v-model="checkAllHm" @change="hmHandleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="checkedHm" @change="hmHandleCheckedChange" style="display: block;">
            <el-checkbox v-for="item in channelListHm" :label="item" :key="item" style="margin:0;width:33%;" size="small"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div style="margin-bottom: 16px;padding-bottom: 16px; border-bottom: 1px solid #ededed;">
          <label style="font-weight: bold;margin-bottom: 8px;">IOS平台：</label>&nbsp;
          <el-checkbox :indeterminate="isIndeterminateIos" v-model="checkAllIos" @change="iosHandleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="checkedIos" @change="iosHandleCheckedChange" style="display: block;">
            <el-checkbox v-for="item in channelListIos" :label="item" :key="item" style="margin:0;width:33%;" size="small"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div>
          <label style="font-weight: bold;margin-bottom: 8px;">Android平台：</label>&nbsp;
          <el-checkbox :indeterminate="isIndeterminateAndroid" v-model="checkAllAndroid" @change="androidHandleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="checkedAndroid" @change="androidHandleCheckedChange">
            <el-checkbox v-for="item in channelListAndroid" :label="item" :key="item" style="margin:0;width:33%;" size="small"></el-checkbox>
          </el-checkbox-group>
        </div>
      </el-scrollbar>
      <div style="width: 500px;">
        <el-form ref="formRef" :model="bannerForm" label-width="114px">
          <el-form-item label="模块：" v-if="idx == -1 || bannerType == 1">
            <el-select v-model="modelType" placeholder="Select" style="width: 24em" @change="modelTypeChange">
              <el-option v-for="item in modelTypeArray" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="banner类型：" v-if="modelType == 1 ">
            <el-select v-model="bannerType" placeholder="Select" style="width: 24em" :disabled="idx >-1">
              <el-option v-for="item in bannerTypeArray" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跳转类型：" v-if="bannerType == 1">
            <el-select v-model="type" placeholder="Select" style="width: 24em">
              <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <div v-if="type != 0 && bannerType == 1">
            <el-form-item label="URL地址：">
              <el-input type="text" v-model="bannerForm.url" placeholder="请粘贴需要跳转的链接" style="width:20em;"/>
              <el-button type="primary" style="margin-left: 8px;" @click="checkUrl(bannerForm.url)"><ElIcons name="Promotion" /></el-button>
            </el-form-item>
            <el-form-item label="分享url：">
              <el-input type="text"  v-model="bannerForm.shareUrl" placeholder="请粘贴需要分享的链接" style="width:20em;"/>
              <el-button type="primary" style="margin-left: 8px;" @click="checkUrl(bannerForm.shareUrl)"><ElIcons name="Promotion" /></el-button>
            </el-form-item>
            <el-form-item label="标题：">
              <el-input type="text"  v-model="bannerForm.title" placeholder="请填写标题" style="width:24em;"/>
            </el-form-item>
            <el-form-item label="分享标题：">
              <el-input type="text"  v-model="bannerForm.shareTitle" placeholder="请填写分享标题" style="width:24em;"/>
            </el-form-item>
            <el-form-item label="分享描述：">
              <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="bannerForm.descp" placeholder="请填写描述" style="width:24em;"/>
            </el-form-item>
            <el-form-item label="备注：">
              <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="bannerForm.remark" placeholder="请填写备注" style="width:24em;"/>
            </el-form-item>
          </div>
          <el-form-item label="排序：">
            <el-input v-model="bannerForm.orderNum" placeholder="数字越小，排序越靠前" style="width:24em;"/>
          </el-form-item>
        </el-form>
        <div class="dialog-footer" style="text-align: center;">
          <el-button @click.native="cancel" >取消</el-button>
          <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import { addOrUpdateDiscoveryBanner, getAllChannelList } from "@/api/url";
import { urlReg } from "../../../assets/shared/reg-constant";

export default {
  name: "GiftManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      bannerForm: this.value.bannerForm,
      idx: this.value.ids,
      loading: false,

      files: null,
      src: this.value.ids > -1?this.value.bannerForm.img:'',

      //模块
      modelTypeArray: [
        {label: "发现列表",value: 1},
        {label: "启动图",value: 2}
      ],
      modelType: this.value.bannerForm.modelType?this.value.bannerForm.modelType:1,

      //跳转类型
      typeArray: [
        {label: "不跳转",value: 0},
        {label: "跳转到内部浏览器",value: 1},
        {label: "跳转到外部浏览器",value: 2}
      ],
      type: this.value.bannerForm.type?this.value.bannerForm.type:0,

      //banner类型
      bannerTypeArray: [
        {label: "普通banner",value: 1},
        {label: "广告banner",value: 2},
      ],
      bannerType: this.value.bannerForm.bannerType?this.value.bannerForm.bannerType:1,


      //IOs渠道列表
      channelListIos: [],
      checkAllIos: true,
      checkedIos: [],
      isIndeterminateIos: false,

      //Android渠道列表
      channelListAndroid: [],
      checkAllAndroid: true,
      checkedAndroid: [],
      isIndeterminateAndroid: false,

      //Hm渠道列表
      channelListHm: [],
      checkAllHm: true,
      checkedHm: [],
      isIndeterminateHm: false,

      hmArray:[],
      iosArray:[],
      androidArray: []

    }
  },
  methods: {

    modelTypeChange() {
      this.bannerType = 1
    },


    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    //url跳转
    checkUrl(url){
      if(urlReg.test(url)) {
        window.open(url);
      }else if(url == ''){
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请填写url',
          type: 'warning'
        });
      }else{
        this.$message({
          showClose: true,
          duration: 1000,
          message: 'url地址输入有误',
          type: 'warning'
        });
      }
    },

    //hm
    hmHandleCheckAllChange(val) {
      this.checkedHm = val ? this.channelListHm : [];
      this.isIndeterminateHm = false;
      this.hmArray = [];
    },
    hmHandleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAllHm = checkedCount === this.channelListHm.length;
      this.isIndeterminateHm = checkedCount > 0 && checkedCount < this.channelListHm.length;
      this.hmArray = [];
      for(let i=0;i<checkedCount;i++){
        // let hmStr = '4||';
        // hmStr += value[i];
        this.hmArray.push(value[i]);
      }
    },

    //ios
    iosHandleCheckAllChange(val) {
      this.checkedIos = val ? this.channelListIos : [];
      this.isIndeterminateIos = false;
      this.iosArray = [];
    },
    iosHandleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAllIos = checkedCount === this.channelListIos.length;
      this.isIndeterminateIos = checkedCount > 0 && checkedCount < this.channelListIos.length;
      this.iosArray = [];
      for(let i=0;i<checkedCount;i++){
        // let iosStr = '2||';
        // iosStr += value[i];
        // this.iosArray.push(iosStr);
        this.iosArray.push(value[i]);
      }
    },
    //Android
    androidHandleCheckAllChange(val) {
      this.checkedAndroid = val ? this.channelListAndroid : [];
      this.isIndeterminateAndroid = false;
      this.androidArray = [];
    },
    androidHandleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAllAndroid = checkedCount === this.channelListAndroid.length;
      this.isIndeterminateAndroid = checkedCount > 0 && checkedCount < this.channelListAndroid.length;
      this.androidArray = [];
      for(let i=0;i<checkedCount;i++){
        // let androidStr = '1||';
        // androidStr += value[i];
        // this.androidArray.push(androidStr);
        this.androidArray.push(value[i]);
      }
    },

    //获取所有渠道列表
    getChannelListAll() {
      let _this = this;
      getFormData( getAllChannelList ).then((data) => {
        if(data.code == 200){
          for(let item of data.data) {
            if(item.platformType == 4) {
              _this.channelListHm.push(item.channel);
            }
            if(item.platformType == 2) {
              _this.channelListIos.push(item.channel);
            }
            if(item.platformType == 1) {
              _this.channelListAndroid.push(item.channel);
            }
          }
          if(_this.idx > -1) {
            _this.getChannelList();
          }else{
            _this.checkedHm = _this.channelListHm;
            _this.checkedIos = _this.channelListIos;
            _this.checkedAndroid = _this.channelListAndroid;
          }
        }
      })
    },

    //获取banner对应列表
    getChannelList() {
      for(let item of this.bannerForm.harmonyShowList) {
        if(item != -1) {
          this.checkedHm.push(item);
          this.hmHandleCheckedChange(this.checkedHm);
        }else if(item == -1){
          this.checkedHm = this.channelListHm;
          this.checkAllHm = true;
        }else if(this.checkedHm.length == 0){
          this.checkAllHm = false;
        }
      }
      if(this.bannerForm.harmonyShowList.length == 0) {
        this.checkAllHm = false;
      }
      for(let item of this.bannerForm.iosShowList) {
        if(item != -1) {
          this.checkedIos.push(item);
          this.iosHandleCheckedChange(this.checkedIos);
        }else if(item == -1){
          this.checkedIos = this.channelListIos;
          this.checkAllIos = true;
        }else if(this.checkedIos.length == 0){
          this.checkAllIos = false;
        }
      }
      if(this.bannerForm.iosShowList.length == 0) {
        this.checkAllIos = false;
      }
      for(let item of this.bannerForm.androidShowList) {
        if(item != -1) {
          this.checkedAndroid.push(item);
          this.androidHandleCheckedChange(this.checkedAndroid)
        }else if(item == -1){
          this.checkedAndroid = this.channelListAndroid;
          this.checkAllAndroid = true;
        }else if(this.checkedAndroid.length == 0){
          this.checkAllAndroid = false;
        }
      }
      if(this.bannerForm.androidShowList.length == 0) {
        this.checkAllAndroid = false;
      }
    },

    summit() {
      if(this.type !=0 && this.bannerForm == 1) {
        if (!this.bannerForm.url) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: 'url不能为空',
            type: 'warning'
          });
          return false
        } else if (!urlReg.test(this.bannerForm.url)) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: 'URL地址输入有误',
            type: 'warning'
          });
          return false
        }
        if (!this.bannerForm.shareUrl) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: '分享url不能为空',
            type: 'warning'
          });
          return false
        } else if (!urlReg.test(this.bannerForm.shareUrl)) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: '分享url地址输入有误',
            type: 'warning'
          });
          return false
        }
        if(!this.bannerForm.title) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: '标题不能为空',
            type: 'warning'
          });
          return false
        }
        if(!this.bannerForm.shareTitle) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: '分享标题不能为空',
            type: 'warning'
          });
          return false
        }
        if(!this.bannerForm.descp) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: '分享描述不能为空',
            type: 'warning'
          });
          return false
        }
      }
      if(!this.bannerForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      if(this.checkedIos.length == 0 && this.checkedAndroid.length == 0 && this.checkedHm.length == 0){
        this.$message({
          showClose: true,
          duration: 1000,
          message: '至少选择一个渠道',
          type: 'warning'
        });
        return;
      }
      this.loading = true
      // let platformChannels = [];
      // if(this.checkedIos.length == this.channelListIos.length && this.checkedAndroid.length == this.channelListAndroid.length) {
      //   platformChannels.push('-1||-1');
      // }else{
      //   if(this.checkedIos.length === this.channelListIos.length) {
      //     platformChannels.push('2||-1');
      //   }else if(this.checkedIos.length > 0){
      //     platformChannels = platformChannels.concat( this.iosArray );
      //   }
      //   if(this.checkedAndroid.length === this.channelListAndroid.length) {
      //     platformChannels.push('1||-1');
      //   }else if(this.checkedAndroid.length > 0){
      //     platformChannels = platformChannels.concat( this.androidArray );
      //   }
      // }

      // if(this.bannerForm.showUid && this.bannerForm.showUid != ''){
      //   this.bannerForm.showUid = this.bannerForm.showUid.replace(/\r\n/g,",");
      //   this.bannerForm.showUid = this.bannerForm.showUid.replace(/\n/g,",");
      //   this.bannerForm.showUid = this.bannerForm.showUid.replace(/，/g,",");
      // }

      let param = {};
      if (this.idx > -1) {
        param['id'] = this.bannerForm.id
      } else {
        param['id'] = 0
      }
      param['type'] = this.type
      param['modelType'] = this.modelType
      param['bannerType'] = this.bannerType
      param['orderNum'] = this.bannerForm.orderNum
      param['url'] = this.bannerForm.url
      param['shareUrl'] = this.bannerForm.shareUrl
      param['title'] = this.bannerForm.title
      param['shareTitle'] = this.bannerForm.shareTitle
      param['descp'] = this.bannerForm.descp
      param['remark'] = this.bannerForm.remark
      // param['platformChannels'] = platformChannels.toString();
      if(this.checkedIos.length == this.channelListIos.length) {
        param['iosChannelArr'] = ['-1']
      }else {
        param['iosChannelArr'] = this.iosArray
      }
      if(this.checkedAndroid.length == this.channelListAndroid.length) {
        param['androidChannelArr'] = ['-1']
      }else {
        param['androidChannelArr'] = this.androidArray
      }
      if(this.checkedHm.length == this.channelListHm.length) {
        param['harmonyChannelArr'] = ['-1']
      }else {
        param['harmonyChannelArr'] = this.hmArray
      }
      postFormData(addOrUpdateDiscoveryBanner, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
    this.getChannelListAll();
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
  .showBox {
    width: 540px;
    margin-left: 8px;
    border: 1px solid #ededed;
    padding: 24px 0 24px 32px;
  }
</style>
